import { gql } from 'graphql-request'

export type Collectible = {
  id: string
  title: string
  quarter: string
  image: string
  href: string
}

export const createCollectiblesQuery = () => gql`
  query getCollectibles {
    Collectibles(limit: 100, sort: "-order") {
      docs {
        id
        title
        quarter
        hasContent
        slug
        thumbnail {
          url
          sizes {
            square {
              url
            }
          }
        }
      }
    }
  }
`

export const mapToCollectibles = (data: any): Collectible[] => {
  return data?.Collectibles?.docs?.map((item: any) => ({
    id: item.id,
    title: item.title,
    image: item.thumbnail.sizes.square.url || item.thumbnail.url,
    quarter: item.quarter || '',
    href: item.slug ? `/collectible/${item.slug}` : '',
    hasContent: item.hasContent,
  }))
}
